import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Loader from 'Component/Loader';
import { SIRET_FIELD_LENGTH } from 'Component/MyAccountCompanyForm/MyAccountCompanyForm.config';
import { MixType } from 'Type/Common.type';
import { VALIDATION_INPUT_TYPE_NUMBER } from 'Util/Validator/Config';

import './FieldSiret.style';

/** @namespace PeggysagePwa/Component/FieldSiret/Component */
export class FieldSiretComponent extends PureComponent {
    static propTypes = {
        defaultValue: PropTypes.string.isRequired,
        isRequired: PropTypes.bool.isRequired,
        isDisabled: PropTypes.bool.isRequired,
        mix: MixType.isRequired,
        fieldsetMix: MixType.isRequired,
        isSiretLoading: PropTypes.bool.isRequired,
        isSiretAlreadyUsed: PropTypes.bool.isRequired,
        validateSiretField: PropTypes.func.isRequired
    };

    render() {
        const {
            defaultValue,
            isRequired,
            isDisabled,
            mix,
            fieldsetMix,
            isSiretLoading,
            isSiretAlreadyUsed,
            validateSiretField
        } = this.props;

        const fieldLength = SIRET_FIELD_LENGTH;

        return (
            <fieldset block="FieldSiret" elem="Legend" mix={ fieldsetMix }>
                <Loader isLoading={ isSiretLoading } />
                <Field
                  type={ FIELD_TYPE.text }
                  label={ __('SIRET') }
                  attr={ {
                      name: 'siret',
                      defaultValue,
                      placeholder: __('SIRET'),
                      maxLength: fieldLength
                  } }
                  isDisabled={ isDisabled }
                  addRequiredTag={ isRequired }
                  validationRule={ !isDisabled ? {
                      inputType: VALIDATION_INPUT_TYPE_NUMBER.numeric,
                      isRequired,
                      match: (value) => value.length === fieldLength || (!isRequired && value.length === 0),
                      customErrorMessages: {
                          onMatchFail: __('Minimum %s characters!', fieldLength)
                      }
                  } : {} }
                  validateOn={ ['onChange', 'onBlur'] }
                  events={ {
                      // onBlur: validateSiretField,
                      onChange: validateSiretField
                  } }
                  mix={ {
                      block: 'FieldSiret',
                      elem: 'Field',
                      mods: { isDisabled, hasError: isSiretAlreadyUsed && !isDisabled },
                      ...mix
                  } }
                />
                { isSiretAlreadyUsed && !isDisabled && (
                    <div className="Field-ErrorMessages">
                        <div className="Field-ErrorMessage">
                            { __('This SIRET is already used by another pro account.') }
                        </div>
                    </div>
                ) }
            </fieldset>
        );
    }
}

export default FieldSiretComponent;
